module.exports = __webpack_public_path__ + "img/wx.dfa99614.png";